import {
  searchSummariesWithFilter,
  searchSummariesWithFilterBeta,
  searchSupportLitWithFilter,
  searchSupportLitWithFilterBeta,
} from '../../../services/studies';

export default function executeSearch(
  searchQuery,
  setSummarizedCallback,
  setSupportCallback = null,
  betaSearch = false
) {
  const promiseArray = [
    !betaSearch
      ? searchSummariesWithFilter(searchQuery)
      : searchSummariesWithFilterBeta(searchQuery),
  ];
  if (setSupportCallback)
    promiseArray.push(
      !betaSearch
        ? searchSupportLitWithFilter(searchQuery)
        : searchSupportLitWithFilterBeta(searchQuery)
    );

  return Promise.allSettled(promiseArray)
    .then((settledResults) => {
      const output = {};
      settledResults.forEach((result) => {
        if (result.status === 'fulfilled') {
          const { promiseId, res } = result.value;
          output[promiseId] = res;
        } else {
          console.error('Search promise failed:', result.reason);
        }
      });
      if (output.summarized) setSummarizedCallback(output.summarized);
      if (output.support && setSupportCallback) setSupportCallback(output.support);
      return output;
    })
    .catch((error) => console.error(error));
}

export function executeSearchPageChange(
  searchQuery,
  groupType,
  page,
  callback,
  betaSearch = false
) {
  const pageQuery = { ...searchQuery, page, perPage: 25 };

  if (groupType === 'support') {
    // Support lit has no studyType param — omit it so the backend treats it as a single-group call
    delete pageQuery.studyType;
    const searchFn = betaSearch ? searchSupportLitWithFilterBeta : searchSupportLitWithFilter;
    return searchFn(pageQuery)
      .then(({ res }) => {
        callback(res);
        return res;
      })
      .catch((error) => {
        console.error(`Page change failed for group ${groupType}:`, error);
        callback(null);
      });
  } else {
    // Summarized study type (1-5) — add studyType to the query
    pageQuery.studyType = groupType;
    const searchFn = betaSearch ? searchSummariesWithFilterBeta : searchSummariesWithFilter;
    return searchFn(pageQuery)
      .then(({ res }) => {
        callback(res);
        return res;
      })
      .catch((error) => {
        console.error(`Page change failed for group ${groupType}:`, error);
        callback(null);
      });
  }
}
